import { Component, Input, OnInit, OnDestroy, Self, Optional } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'flow-form-date-picker',
  templateUrl: './form-date-picker.component.html',
  styleUrls: ['./form-date-picker.component.scss'],
})
export class FormDatePickerComponent implements OnInit, OnDestroy, ControlValueAccessor {
  destroy$ = new Subject<void>();
  @Input() label: string = '';
  @Input() multiple: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() required: boolean = false;
  @Input() selectAll: boolean = false;
  @Input() infoTooltip: string = '';
  @Input() placeholder: string = '';
  @Input() dateRangeValidation: { minDate?: DateTime | null; maxDate?: DateTime | null } = { minDate: null, maxDate: null };
  value: DateTime | null = null;
  disabled = false;
  isLoaded = false;

  constructor(@Optional() @Self() protected control: NgControl, private translate: TranslateService) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  ngOnInit() {
    this.translate
      .get([this.placeholder])
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isLoaded = true;
      });
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onDateChanged(event: DateTime | null) {
    this.value = event;
    this.onChange(event);
    this.onTouched();
  }

  clearDatePicker(): void {
    this.value = null;
    this.onChange(null);
    this.onTouched();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
